export default "__VITE_ASSET__DXJWzD8r__"